// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const ClaimMarketingReferenceInfo = t.struct({
    referenceNumber1: t.String,
    referenceNumber2: t.maybe(t.String),
    referenceNumber3: t.maybe(t.String),
    repairNumber: t.maybe(t.String)
}, {
    name: 'ClaimMarketingReferenceInfo',
    strict: true
});

export const getDefaultState = () => new ClaimMarketingReferenceInfo({
    referenceNumber1: ''
});

export default ClaimMarketingReferenceInfo;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-marketing-reference-info.js